export default class InfoSpot {
    constructor( props ) {
        this.id = props.ID ?? props.spot.ID;
        this.type = props.post_type ?? props.spot.post_type;
        this.title = props.title ?? props.spot.post_title;
        this.excerpt = props.excerpt ?? props.spot.post_excerpt;
        this.content = props.content  ?? props.spot.post_content;
        this.pos_x = props.x;
        this.pos_y = props.y;
        this.index = props.index;
        this.thumbnail = props.post_thumbnail ?? props.spot.post_thumbnail;
    }

    get thumbnailUrl() {
        return this.thumbnail.sizes.original.url;
    }

    get hasThumbnail() {
        return this.thumbnail !== null && (typeof this.thumbnail !== 'undefined') && this.thumbnail !== false;
    }

    get isRoom() {
        return this.type === 'room';
    }

}
